import { VStack } from "@chakra-ui/react";
import React from "react";

export default function TableContainer(props: any) {
  return (
    <VStack {...props} w={"100%"} align={"stretch"} overflowX={"auto"} flex={1}>
      {props.children}
    </VStack>
  );
}
